import { UI_PRIMITIVE__button } from '@/components/ui/UI_PRIMITIVE__button';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_workspace_user_delete } from '@/state/workspace/user/remote_workspace_user_delete';
import { RequestWorkspaceUserDelete } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_delete';

export function ButtonWorkspaceLeave() {
  const dispatch = use_dispatch();

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);

  async function onClick() {
    let request = new RequestWorkspaceUserDelete();
    request.workspace_id = current_workspace_user.workspace_id;
    request.workspace_user_id = current_workspace_user._id;

    await dispatch(remote_workspace_user_delete(request));
  }

  if (current_workspace_user.is_stub()) return <></>;

  return (
    <UI_PRIMITIVE__button variant={'outline-on-component'} className="text-danger" {...{ onClick }}>
      Leave workspace
    </UI_PRIMITIVE__button>
  );
}
